import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import linkifyRegex from "remark-linkify-regex";

import renderers from "./renderers";
import { linkRegexp } from "./constants";
import { transformLinkUri } from "./functions";

const remarkPlugins = [linkifyRegex(linkRegexp), remarkGfm];

type Props = {
  message: string;
};

function MessageWithLinks(props: Props) {
  const { message } = props;
  return (
    <ReactMarkdown
      remarkPlugins={remarkPlugins}
      transformLinkUri={transformLinkUri}
      components={renderers}
    >
      {message}
    </ReactMarkdown>
  );
}

export default MessageWithLinks;
